export default class Thankyou {
  constructor() {
    this.handleCopyButton();
    this.initPaymentStatusPolling();
  }

  handleCopyButton() {
    const buttons = document.querySelectorAll(".copy-button");

    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        const text = button.getAttribute("data-text");
        const input = document.querySelector(".copy-input");

        try {
          navigator.clipboard.writeText(text);
          input.select();
        } catch (error) {
          input.select();
          document.execCommand("copy");
        }
      });
    });
  }

  initPaymentStatusPolling() {
    const pixDetails = document.querySelector('.vindi-pagamentos-order-details');
    const orderIdInput = document.getElementById('vindi-order-id');
    
    if (!pixDetails || !orderIdInput) {
      return;
    }

    const orderId = orderIdInput.value;
    
    if (!orderId) {
      return;
    }

    if (typeof vindiPaymentStatus === 'undefined') {
      return;
    }
    
    this.startPolling(orderId);
  }

  startPolling(orderId) {
    let attempts = 0;
    const maxAttempts = 60;
    
    const pollingInterval = setInterval(() => {
      attempts++;
      
      if (attempts > maxAttempts) {
        clearInterval(pollingInterval);
        return;
      }

      this.checkPaymentStatus(orderId, pollingInterval);
    }, 10000);
  }

  checkPaymentStatus(orderId, pollingInterval) {
    if (typeof vindiPaymentStatus === 'undefined') {
      clearInterval(pollingInterval);
      return;
    }

    const data = new FormData();
    data.append('action', 'vindi_check_payment_status');
    data.append('order_id', orderId);
    data.append('nonce', vindiPaymentStatus.nonce);

    fetch(vindiPaymentStatus.ajaxUrl, {
      method: 'POST',
      body: data
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      if (data.success) {        
        if (data.data.paid) {
          clearInterval(pollingInterval);
          this.showPaymentConfirmation(data.data);
        }
      }
    })
    .catch(error => {
      console.error('[Vindi] Erro:', error);
    });
  }

  showPaymentConfirmation(data) {    
    const orderDetails = document.querySelector('.vindi-pagamentos-order-details .order_details');
    if (orderDetails) {
      orderDetails.style.display = 'none';
    }

    const statusInfo = document.querySelector('.wvp-payment-status-info');
    if (statusInfo) {
      statusInfo.classList.add('hidden');
    }

    const orderNumberSpan = document.querySelector('.vindi-order-number');
    if (orderNumberSpan) {
      orderNumberSpan.textContent = `Pedido #${data.order_number}`;
    }

    const notification = document.querySelector('.vindi-payment-confirmation');
    if (notification) {
      notification.classList.add('show');
    }
  }
}

